/* eslint-disable react-hooks/rules-of-hooks */
'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { removeUrlParameters } from '@/helpers/common';
import {
  AUTH_MODALS_MAP,
  MODAL_QUERY_KEY,
  ModalQueryByName,
  type Modals,
  NON_AUTH_MODALS_MAP,
} from '@/helpers/modals';
import { useGetCommonStore } from '@/store';

export const useDialogs = () => {
  if (typeof window === 'undefined') return { modal: undefined };

  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const nextSearch = useSearchParams();

  const [modalQuery, setModalQuery] = useState<Modals | undefined>(undefined);

  useEffect(() => {
    const searchParams = nextSearch.toString()
      ? nextSearch
      : new URLSearchParams(window.location.search);
    const modalQueryKey = searchParams.get(MODAL_QUERY_KEY);

    if (!modalQueryKey) {
      setModalQuery(undefined);
      return;
    }

    const modal = Object.keys(ModalQueryByName).find(
      (key) => ModalQueryByName[key as Modals] === modalQueryKey
    ) as Modals;

    if (!modal) {
      setModalQuery(undefined);
      return;
    }

    const isNonAuthModal = NON_AUTH_MODALS_MAP.includes(modal);
    const isAuthModal = AUTH_MODALS_MAP.includes(modal);

    if (isAuthenticated && isNonAuthModal) {
      setModalQuery(undefined);
      removeUrlParameters([MODAL_QUERY_KEY]);
      return;
    }
    if (!isAuthenticated && isAuthModal) {
      setModalQuery(undefined);
      removeUrlParameters([MODAL_QUERY_KEY]);
      return;
    }

    setModalQuery(modal);
  }, [nextSearch, isAuthenticated]);

  return { modal: modalQuery };
};
